export default __webpack_public_path__ + "static/media/651.8efc86e3.png";